
import { Booking } from '@/interfaces/booking.interface'
import { Building, Item } from '@/interfaces/building.interface'
import router from '@/router'
import { apiUrl, axiosAuthGet, axiosAuthPost } from '@/services/utils'
import { defineComponent, ref } from 'vue'
import { DoughnutChart } from 'vue-chart-3'
import { BarChart } from 'vue-chart-3'
import { Chart, registerables } from "chart.js"
import { MainTask } from '@/interfaces/mainTask.interface'
import { Expense } from '@/interfaces/expense.interface'
import { Payment } from '@/interfaces/payment.interface'
import OverlayLoader from '@/components/OverlayLoader.vue'
import { topBarState } from "@/services/topBar";
import Knob from 'primevue/knob';
import { Chart as HighChart } from 'highcharts-vue'
import Highcharts from 'highcharts'
import Xrange from 'highcharts/modules/xrange'
import { Apartment } from '@/interfaces/apartment.interface'
import { addCalendarProps, CalendarState } from '@/services/CalendarService'
import { getDashboardDetails } from '@/services/DashboardService'
import { getAllApartments } from '@/services/ApartmentService'
import { CalendarData } from '@/interfaces/calendar.interface'
import { DateService, getFormattedDate, getReadableDate, getReadableDateNoTime, lastMonth, today } from '@/services/DateService'
import Calendar from 'primevue/calendar'
import ChartDataLabels from 'chartjs-plugin-datalabels';
Xrange(Highcharts)

Chart.register(...registerables, ChartDataLabels)

export default defineComponent({
    components: { DoughnutChart, BarChart, OverlayLoader, Knob, highcharts: HighChart, Calendar },
    setup() {

    },
    mounted() {
        topBarState.updateTitle('dashboard');
        this.chartState.chartOptions.chart.height = 200;
        this.getBuildingInfo();
    },
    data() {
        let self = this;
        return {
            // variables needed to graph revenues
            revenueData: {
                labels: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', , '29', '30'] as any[],
                datasets: [
                    {
                        data: [1000, 10000, 2000, 3000, 4000, 1000, 9000, 5000, 6000, 3000, 4000, 3000, 5000, 2000, 2000, 3000, 4000, 5000, 4000, 5000, 1000, 5000, 2000, 3000, 7000, 8000, 5000, 4000, 3000, 5000, 7000, 6000] as number[],
                        backgroundColor: ['#C5A753'],
                    },
                ]
            },
            // variables needed to graph expenses
            expenseData: {
                labels: [] as any[],
                datasets: [
                    {
                        data: [0, 0, 0],
                        backgroundColor: ['rgba(255, 99, 132, 0.6)'],
                    },
                ]
            },
            // variables needed to graph income/expense summary
            incomeData: {
                labels: ['revenue', 'expenses'] as any[],
                datasets: [
                    {
                        data: [0, 0],
                        backgroundColor: ['#1362FC', '#F11616'],
                    },
                ]
            },
            // variables for chartjs options
            options: {
                responsive: true,
                onClick: function (evt: any) {
                    self.navigateIncome()
                    // console.log(evt)
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    datalabels: {
                        anchor: 'center',
                        align: 'center',
                        clamp: false,
                        color: "#2c3e50",
                        weight: 'bold',
                        clip: false,
                        formatter: function (value: number, context: any) {
                            return value.toLocaleString();
                        }
                    }
                },
                scales: {
                    x: {
                        stacked: true,
                        grid: {
                            display: false,
                            drawBorder: false,
                        }
                    },
                    y: {
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                        ticks: {
                            // remove labels
                            display: false
                        }
                    },
                    xAxes: [{
                        gridLines: {
                            display: false,
                            color: "rgba(0, 0, 0, 0)",
                        }
                    }],
                    yAxes: [{
                        ticks: {
                            display: false //this will remove only the label
                        },
                        gridLines: {
                            display: false,
                            color: "rgba(0, 0, 0, 0)",
                        }
                    }]
                },


            },
            // show overlay loader
            load: false,
            currentBuilding: {} as Building,
            buildings: [] as Building[],
            currentBooking: {} as Booking,
            moreBookingDetails: false,
            itemForm: false,
            freeApartments: 0,
            totalApartments: 0,
            bookingsNumber: 0,
            checkIns: 0,
            checkOuts: 0,
            repairs: 0,
            totalIncome: 0,
            totalExpense: 0,
            bookings: [] as Booking[],
            apartments: [] as Apartment[],
            tasks: [] as MainTask[],
            payments: [] as Payment[],
            expenses: [] as Expense[],
            period: 'This year',
            dateService: new DateService(),
            // filtering variables
            /**
             * start and end dates
             */

            startDate: '',
            endDate: '',
            calendarStart: '',
            calendarEnd: '',
            itemFormData: {
                name: '',
                price: ''
            },
            // variables needed to graph calendar
            chartState: CalendarState.state
        }
    },
    computed: {

    },
    methods: {
        // displays more information on bookings list
        showMoreBookingDetails(booking: Booking) {
            this.currentBooking = booking;
            this.moreBookingDetails = !this.moreBookingDetails;
        },
        filterPeriod(period: string) {
            this.period = period;
            if (this.period == 'This month') {
                this.startDate = this.dateService.formatDateForApi(this.dateService.lastMonth)
                this.getBuildingInfo()
            } else if (this.period == 'This week') {
                this.startDate = this.dateService.formatDateForApi(this.dateService.lastWeek)
                this.getBuildingInfo()
            } else {
                this.startDate = this.dateService.formatDateForApi(this.dateService.year);
                this.getBuildingInfo()
            }
        },
        // custom filter period
        customFilter() {
            this.startDate = this.dateService.formatDateForApi(this.calendarStart);
            this.endDate = this.dateService.formatDateForApi(this.calendarEnd);
            this.getBuildingInfo()
        },
        // navigate to incomes page
        navigateIncome() {
            this.$router.push({ name: 'Payments', params: { building: this.$route.params.building } })
        },
        async switchBuilding(building: Building) {
            // await this.$router.push('/building/' + building._id);
            // this.$router.go(0);
            window.open('/building/'+building._id, '_self')
            // await this.getBuildingInfo();

        },
        async getBuildingInfo() {
            this.load = true;
            this.totalExpense = 0;
            this.totalIncome = 0;
            this.incomeData.datasets[0].data[0] = 0;
            this.incomeData.datasets[0].data[1] = 0;
            let results = await getDashboardDetails(this.startDate, this.endDate)
            this.bookingsNumber = results.bookings;
            this.totalApartments = results.total_apartments;
            this.freeApartments = results.free_apartments;
            this.checkIns = results.check_ins;
            this.currentBuilding = results.building;
            this.checkOuts = results.check_outs;
            this.bookings = results.latest_bookings;
            this.repairs = results.total_repairs;
            this.tasks = results.latest_tasks;
            this.payments = results.latest_payments;
            this.expenses = results.latest_expenses;
            this.buildings = results.buildings;
            topBarState.updateBuildingName(this.currentBuilding);
            this.load = false;
            this.getApartments();
            // this.graphRevenue();
            // this.graphExpenses();
        },
        getReadDate(date: Date) {
            return getReadableDate(date);
        },
        getReadDateNotTime(date: Date) {
            return getReadableDateNoTime(date);
        },
        getFormatDate(date: any) {
            return getFormattedDate(date);
        },
        graphRevenue() {
            // get list of dates from payment transactions
            let labels = this.payments.map(payment => this.getFormatDate(payment.created_at));
            // make the list of dates unique
            let uniqueLabels = this.uniqueArrayTransform(labels);
            this.revenueData.labels = uniqueLabels;
            let data = [] as any[];
            /*
            ******
            getting transactions associated to each date 
            getting only amount from these transactions
            putting transactions in array of arrays of numbers(matrix)
            ******
            */
            uniqueLabels.forEach((label, index) => {
                data[index] = this.payments.filter(pay => this.getFormatDate(pay.created_at) == label).map(pay => pay.amount);
            });
            // summing all internal arrays to produce a single array of number
            let reducedData = [] as number[];
            data.forEach((d, index) => {
                let sum = d.reduce((a: number, b: number) => a + b);
                reducedData.push(sum)
            });
            this.revenueData.datasets[0].data = reducedData;
            this.totalIncome = reducedData.reduce((a: number, b: number) => a + b);
            this.incomeData.datasets[0].data[0] = this.totalIncome;
            this.graphExpenses();
        },
        graphExpenses() {
            // get list of dates from payment transactions
            let labels = this.expenses.map(expense => this.getFormatDate(expense.created_at));
            // make the list of dates unique
            let uniqueLabels = this.uniqueArrayTransform(labels);
            this.expenseData.labels = uniqueLabels;
            let data = [] as any[];
            /*
            ******
            getting transactions associated to each date 
            getting only amount from these transactions
            putting transactions in array of arrays of numbers(matrix)
            ******
            */
            uniqueLabels.forEach((label, index) => {
                data[index] = this.expenses.filter(expense => this.getFormatDate(expense.created_at) == label).map(expense => expense.amount);
            });
            // summing all internal arrays to produce a single array of number
            let reducedData = [] as number[];
            data.forEach((d, index) => {
                let sum = d.reduce((a: number, b: number) => a + b);
                reducedData.push(sum)
            });
            this.expenseData.datasets[0].data = reducedData;
            this.totalExpense = reducedData.reduce((a: number, b: number) => a + b);
            this.incomeData.datasets[0].data[1] = this.totalExpense;
            this.getApartments();
        },
        // sort and make an array unique
        uniqueArrayTransform(array: any[]) {
            return array.sort().filter(function (item, pos, ary) {
                return !pos || item != ary[pos - 1];
            });
        },
        bookingsCalendar() {
            // adds new required fields to the bookings fields to be plotted on the graph
            let mappedBookings = this.bookings.map((book) => {
                const newPropsObj = addCalendarProps(book.check_in, book.check_out, this.chartState.chartOptions.yAxis.categories, '#cdb46c', (book.clientDetails?.name || ''), book.amount_to_pay, (book.apartmentDetails?.name || ''))
                return Object.assign(book, newPropsObj);
            })
            this.chartState.chartOptions.series[0].data = mappedBookings;
            this.graphRevenue()
        },
        async getApartments() {
            this.apartments = await getAllApartments();
            // plot all apartment names on the y axis of the calendar
            this.chartState.chartOptions.yAxis.categories = this.apartments.map(apart => apart.name);
            // limits the length of the y-axis to the number of apartments
            this.chartState.chartOptions.yAxis.max = this.apartments.length - 1;
            this.chartState.chartOptions.chart.height = 260;
            // go to calendar page when clicked
            this.chartState.chartOptions.plotOptions.series.point.events.click = this.gotoCalendar();
            // convert the bookings to calendar compatible
            this.bookingsCalendar();
        },
        gotoCalendar() {
            return () => {
                this.$router.push({ name: 'Calendar', params: { building: this.$route.params.building } })
            }
        }
    }
})
